import React from 'react';
import PropTypes from 'prop-types';
import { LinearProgress, RaisedButton } from 'material-ui';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import get from 'lodash.get';

import { showNotification as showNotificationAction } from 'admin-on-rest';
import { connect } from 'react-redux';
import { URL_PROJECT_REACTIVATE } from '../constants.js';
import fetcher from '../helpers/fetcher';
import { projectReactivate as projectReactivateAction } from '../actions/customProjectActions';
import { STATUSES } from '../helpers/contacts.js';

class ProjectReactivate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTextLabel: '',
      statuses: [],
      loading: false
    };
  }
  _onClick = () => {
    this.props.projectReactivate(this.props.record.id, {
      projectId: this.props.record.id
    });
  };

  _onReactivateClick = filename => {
    this.setState({ loading: true });
    // fetcher.get(`${URL_REACTIVATE}/${this.props.record.id}`)
    const criteria = {};
    if (this.state.statuses && this.state.statuses.length) {
      criteria.status = this.state.statuses;
    }
    if (this.props.updatedAtAfter) {
      if (!criteria.updatedAt) {
        criteria.updatedAt = {};
      }
      criteria.updatedAt['>'] = this.props.updatedAtAfter;
    }
    if (this.props.updatedAtBefore) {
      if (!criteria.updatedAt) {
        criteria.updatedAt = {};
      }
      criteria.updatedAt['<'] = this.props.updatedAtBefore;
    }

    fetcher
      .post(`${URL_PROJECT_REACTIVATE}`, {
        projectId: this.props.record.id || [-1],
        criteria
      })
      .then(response => {
        const contacts = get(response, 'data.data.contactsUpdated');
        this.setState({ loading: false });
        this.props.showNotification(`Reactivated ${contacts} contacts`);
      });
  };

  _handleStatusSelectChange = (event, index, values) =>
    this.setState({ statuses: values });

  render() {
    return (
      <div>
        <h4>Reactivation</h4>
        {this.props.loading !== 0 && <LinearProgress />}

        <SelectField
          multiple={true}
          hintText="Select statuses (or leave empty)"
          value={this.state.statuses}
          onChange={this._handleStatusSelectChange}
        >
          {STATUSES.map(name => (
            <MenuItem
              key={name}
              insetChildren={true}
              checked={
                this.state.statuses && this.state.statuses.indexOf(name) > -1
              }
              value={name}
              primaryText={name}
            />
          ))}
        </SelectField>

        <RaisedButton
          disabled={!!this.props.loading}
          primary
          label="Reactivate"
          onClick={this._onReactivateClick}
        />
      </div>
    );
  }
}
ProjectReactivate.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.number,
    exports: PropTypes.arrayOf(
      PropTypes.shape({
        filename: PropTypes.string
      })
    )
  }),
  updatedAtAfter: PropTypes.object,
  updatedAtBefore: PropTypes.object,
  projectExport: PropTypes.func,
  loading: PropTypes.number,
  showNotification: PropTypes.func,
  projectReactivate: PropTypes.func
};

export default connect(
  state => ({
    loading: state.admin.loading
  }),
  {
    showNotification: showNotificationAction,
    projectReactivate: projectReactivateAction
  }
)(ProjectReactivate);



// WEBPACK FOOTER //
// ./src/components/ProjectReactivate.js